<div class="main-body">
    <div class="sweet-spot-page-content view">
        <div class="row mx-4 mt-4 top-section">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-2">
                <button mat-flat-button color="border" class="close-btn" (click)="goToList()">
                    <mat-icon>close</mat-icon> {{ 'CLOSE' | translate }}
                </button>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="row w-auto">
                    <div class="col-lg-4">
                        <label for="firstName" class="form-label mt-md-3">{{ 'SWEET_SPOT_NAME' | translate }}</label>
                    </div>
                    <div class="col-lg-8">
                        <mat-form-field class="w-100">
                            <input matInput type="text" id="firstName" placeholder="{{ 'SENIOR_CITIZEN' | translate }}"
                                [value]="SweetSpotName" disabled>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-4">
                <div class="row w-auto">
                    <div class="col-lg-4">
                        <mat-form-field class="w-100">
                            <mat-select placeholder="{{ 'SELECT_DATE_PLACEHOLDER' | translate }}" [(ngModel)]="SelectedHistoryDate"
                              [matTooltip]="'SELECT_DATE_PLACEHOLDER' | translate"  matTooltipPosition="above">
                                <mat-option [value]="null">
                                    --Select--
                                </mat-option>
                                @for (date of HistoryDateList; track date) {
                                <mat-option [value]="date.ChangeDate">
                                    {{date.ChangeDate | date:'MM/dd/yyyy HH:mm:ss'}}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-8">
                        <div class="d-flex flex-lg-nowrap flex-wrap gap-3 align-items-start">
                            <button mat-flat-button color="border" class="close-btn" (click)="viewHistory()">
                               {{ 'VIEW_HISTORY' | translate }}
                            </button>
                            <ul class="sweet-spot-details" *ngIf="sweetspotData?.AgentId">
                                <li>
                                    <div class="d-flex flex-column">
                                        <div class="d-flex flex-nowrap gap-2">
                                        <h6>{{ 'AGENT_ID' | translate }}:</h6>
                                        <p class="date">{{sweetspotData?.AgentId}}</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex flex-column">
                                        <div class="d-flex flex-nowrap gap-2">
                                        <h6>{{ 'AGENT_NAME' | translate }}:</h6>
                                            <p class="date">{{sweetspotData?.AgentName}}</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex flex-column">
                                        <div class="d-flex flex-nowrap gap-2">
                                        <h6>{{ 'RECEIVED_DATE' | translate }}:</h6>
                                            <p class="date">{{sweetspotData?.ReceivedDate | date:'MM/dd/yyyy' }}</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex flex-column">
                                        <div class="d-flex flex-nowrap gap-2">
                                        <h6>{{ 'STATUS' | translate }}:</h6>
                                        <p class="date" *ngIf="sweetspotData.SweetSpotStatus === 'Received'">
                                            <!-- <span class="text-purple">{{ (sweetspotData.UserType === 4 && sweetspotData.SweetSpotStatus === 'Received') ? 'Sent' : sweetspotData.SweetSpotStatus }}</span> -->
                                            <span class="text-purple">
                                                {{
                                                    UserType === 4 && sweetspotData.UserType === 4 && sweetspotData.SweetSpotStatus === 'Received' 
                                                    ? 'Sent' 
                                                    : UserType === 3 && sweetspotData.SweetSpotStatus === 'Received'
                                                      ? 'Received'
                                                      : sweetspotData.SweetSpotStatus
                                                }}
                                              </span>
                                          </p>
                                          <p class="date" *ngIf="sweetspotData.SweetSpotStatus === 'Approved'">
                                            <span class="text-success">{{ sweetspotData.SweetSpotStatus }} - {{ sweetspotData.ApprovedDate | date:'MM/dd/yyyy' }}</span>
                                          </p>
                                          <p class="date" *ngIf="sweetspotData.SweetSpotStatus === 'Declined'">
                                            <span class="text-danger">{{ sweetspotData.SweetSpotStatus }} - {{ sweetspotData.DeclinedDate | date:'MM/dd/yyyy' }}</span>
                                          </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                      
                    </div>
                </div>

              
            </div>
        </div>
        <div class="sweet-spot-tab px-4">
            <div class="row w-100">
                <div class="col-12">
                    <div class="d-flex flex-wrap flex-md-nowrap w-100">
                        <div ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav-pills flex-column"
                            orientation="vertical">
                            <!--tab-1-->
                            <ng-container ngbNavItem="demographics">
                                <button ngbNavLink (click)="goToPage('demographics')">
                                    {{ 'DEMOGRAPHICS' | translate }}
                                </button>
                                <ng-template ngbNavContent>
                                </ng-template>
                            </ng-container>

                            <ng-container ngbNavItem="geographic">
                                <button ngbNavLink (click)="goToPage('geographic')">
                                    {{ 'GEOGRAPHIC' | translate }}
                                </button>
                                <ng-template ngbNavContent></ng-template>
                            </ng-container>

                            <ng-container ngbNavItem="house-hold-status">
                                <button ngbNavLink (click)="goToPage('house-hold-status')">
                                   {{ 'HOUSE_HOLD_STATUS' | translate }}
                                </button>
                                <ng-template ngbNavContent></ng-template>
                            </ng-container>

                            <ng-container ngbNavItem="driving-record">
                                <button ngbNavLink (click)="goToPage('driving-record')">
                                   {{ 'DRIVING_RECORD' | translate }}
                                </button>
                                <ng-template ngbNavContent></ng-template>
                            </ng-container>

                            <ng-container ngbNavItem="vehicle-information">
                                <button ngbNavLink (click)="goToPage('vehicle-information')">
                                   {{ 'VEHICLE_INFO' | translate }}
                                </button>
                                <ng-template ngbNavContent></ng-template>
                            </ng-container>

                            <ng-container ngbNavItem="current-carrier-history">
                                <button ngbNavLink (click)="goToPage('current-carrier-history')">
                                    {{ 'CURRENT_CARRIER_HISTORY' | translate }}
                                </button>
                                <ng-template ngbNavContent></ng-template>
                            </ng-container>

                            <ng-container ngbNavItem="coverage-limit">
                                <button ngbNavLink (click)="goToPage('coverage-limit')">
                                   {{ 'COVERAGE_LIMIT' | translate }}
                                </button>
                                <ng-template ngbNavContent>

                                </ng-template>
                            </ng-container>

                            <ng-container ngbNavItem="sweetspot-applicability">
                                <button ngbNavLink (click)="goToPage('sweetspot-applicability')">
                                    {{ 'SWEETSPOTS_APPLICABILITY' | translate }}
                                </button>
                                <ng-template ngbNavContent></ng-template>
                            </ng-container>

                            <ng-container ngbNavItem="customer-contact-preference">
                                <button ngbNavLink (click)="goToPage('customer-contact-preference')">
                                    {{ 'CUSTOMER_CONTACT_PREFERNECE' | translate }}
                                </button>
                                <ng-template ngbNavContent></ng-template>
                            </ng-container>

                            <ng-container ngbNavItem="lead-generation-source">
                                <button ngbNavLink (click)="goToPage('lead-generation-source')">
                                  {{ 'LEAD_GENERATION_SOURCE' | translate }}
                                </button>
                                <ng-template ngbNavContent></ng-template>
                            </ng-container>
                        </div>
                        <!-- <div [ngbNavOutlet]="nav"> -->
                        <div class="ms-md-5 tab-content w-100">
                            <router-outlet></router-outlet>
                        </div>
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>